var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.userID)?_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":_vm.createAccount}},[_vm._v("Create Account")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }